export default "__VITE_ASSET__C9v5qcyE__"